"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWrapper = exports.MobileLanguageSelectorWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var MobileLanguageSelectorWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileLanguageSelectorstyle__MobileLanguageSelectorWrapper",
  componentId: "sc-5kxrit-0"
})(["width:320px;max-width:100%;@media (min-width:", "){display:none;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.lg;
});
exports.MobileLanguageSelectorWrapper = MobileLanguageSelectorWrapper;
var TitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "MobileLanguageSelectorstyle__TitleWrapper",
  componentId: "sc-5kxrit-1"
})(["display:flex;align-items:center;"]);
exports.TitleWrapper = TitleWrapper;